export const url =
  // "https://7i5apes6bk.execute-api.ap-northeast-2.amazonaws.com/v1";
  "https://8i95jcc1yf.execute-api.ap-northeast-2.amazonaws.com/v1/kalisco";

export const CRM_URL = "https://api.kalisco.co.kr";
// export const CRM_URL = "http://outerpos-test.imtsoft.me";
